import { Mod } from "@/services/api";

export default {
   actions: {
      resetTour() {
         return Mod.find("Tour", "reset").create();
      }
   }
};
